import { parsePhoneNumberFromString } from 'libphonenumber-js';

export default function phoneNumberIsValid(phoneNumber, countryCode = 'US') {
  const parsedPhoneNumber = parsePhoneNumberFromString(phoneNumber, countryCode);
  return parsedPhoneNumber && parsedPhoneNumber.isPossible();
}
